import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Global gate: if the backend says an active subscription is required (402), send the user to billing.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 402) {
      const path = window.location.pathname;
      if (path !== "/billing" && !path.startsWith("/payment")) {
        window.location.href = "/billing";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
